import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import WorkersList from '../../components/WorkersList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadPersonal } from '../../actions/PersonalActions';

class PageWorkers extends Component {
  static requestData(store) {
    return requestAll([loadPersonal], store);
  }

  render() {
    return (
      <div className="container container--indentVertical">
        <Helmet>
            <title>Отзывы и истории успеха в компании ЭР-Телеком Холдинг</title>
            <meta name="description" content="Читайте реальные отзывы о работе, истории успеха сотрудников и карьерных возможностях. Узнайте о трудоустройстве с реальными примерами и мнениями в нашей компании, в Перми." />
        </Helmet>
        <h1 className="text--hide">Истории успеха в компании ЭР-Телеком</h1>
        <h2 className="text text--h2">Истории успеха</h2>
        <WorkersList cols={4} slidered popular={true} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      personal: state.personal.list,
      hasErrored: state.personal.hasErrored,
      isLoading: state.personal.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadPersonal }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageWorkers));



// WEBPACK FOOTER //
// ./src/pages/PageWorkers/index.js